import { useState } from "react";
import { BioShell, ResultCard, Stat, primaryBtn, BIO_ACCENT } from "./BioShell.jsx";
import { transcribe, complement, reverseComplement, gcContent, round } from "./biocore.js";

export default function DNA() {
  const [seq, setSeq] = useState("ATGGCCATTGTAATGGGCCGCTGAAAGGGTGCCCGATAG");
  const [res, setRes] = useState(null);

  const run = () => {
    const t = transcribe(seq);
    if (!t.ok) { setRes({ err: t.error }); return; }
    setRes({
      mRNA: t.result,
      comp: complement(seq).result,
      revcomp: reverseComplement(seq).result,
      gc: gcContent(seq),
    });
  };

  const mono = { fontFamily: "ui-monospace, Menlo, monospace", fontSize: 13, wordBreak: "break-all", color: "#C8CADF", lineHeight: 1.6 };

  return (
    <BioShell title="DNA / RNA Toolkit">
      <label style={{ fontSize: 13, color: "#9A9DBE", display: "block", marginBottom: 6 }}>DNA sequence (coding strand)</label>
      <textarea
        value={seq}
        onChange={(e) => setSeq(e.target.value)}
        rows={4}
        style={{ width: "100%", background: "#13141F", border: "1px solid #262839", borderRadius: 10, color: "#E8E9F3", fontSize: 14, padding: "12px 14px", boxSizing: "border-box", resize: "vertical", fontFamily: "ui-monospace, Menlo, monospace" }}
      />
      <button onClick={run} style={primaryBtn}>Analyze</button>
      {res && res.err && <ResultCard><span style={{ color: "#F8716A" }}>{res.err}</span></ResultCard>}
      {res && !res.err && (
        <ResultCard>
          <Stat label="Length" value={res.gc.length} unit="bp" />
          <Stat label="GC content" value={round(res.gc.result, 2)} unit="%" />
          <div style={{ marginTop: 14 }}>
            <div style={{ fontSize: 12, color: "#9A9DBE", marginBottom: 4 }}>mRNA (transcribed)</div>
            <div style={mono}>{res.mRNA}</div>
          </div>
          <div style={{ marginTop: 12 }}>
            <div style={{ fontSize: 12, color: "#9A9DBE", marginBottom: 4 }}>Complement</div>
            <div style={mono}>{res.comp}</div>
          </div>
          <div style={{ marginTop: 12 }}>
            <div style={{ fontSize: 12, color: "#9A9DBE", marginBottom: 4 }}>Reverse complement</div>
            <div style={mono}>{res.revcomp}</div>
          </div>
        </ResultCard>
      )}
    </BioShell>
  );
}

